export default __webpack_public_path__ + "src/assets/images/plug/smartplug_EU.png?5a600611";